$(document).ready(() => {
	
	let init = () => {
		animateLogo();
		initDoubleHeroSlider();
		initHalfSlider();
		initDoubleHeroSliderDesk();
		animateDualLogo();
		initHeroSlider();
		initExploreSlider();
		scrollAfterLoad();
		initFeaturedCollectionSlider();
		initPromoProductsSlider();

		initCardImgSlider();
		initLandingSlider();

		initInspiredSapphires();
		loadFilter();
		
		initProductSlider();
		initProductDescription();
		initProductVerticalSlider();
		initProductOptions();

		initOurStorySlider();

		initMGIRLSlider();

		initLifestyleSlider();

		addCustomTitleToCollectionFilter();
		changeRoleSearchPopup();

		addMenuItemParentClass();
		addLifestyleSliderParentClass();
		addProductTabsParentClass();
		
		changeProductTabsText();

		addProductPageAnnouncementClass();
	}

	let toggleMenu = (e) => {
		let menu = $('.menu');
		$('.search-section').slideUp();
		menu.slideToggle();
		if (menu.hasClass('active')) {
			$(e.currentTarget).removeClass('active');
			menu.removeClass('active');
		} else {
			$(e.currentTarget).addClass('active');
			menu.addClass('active');
		}
	}
	let toggleMobileNav = (e) => {
		e.preventDefault();
		let menu = $('.js-mobile-nav-toggle');
		if (menu.hasClass('mobile-nav--close')) {
			menu.click();
		}
	}

	let toggleHeaderSearch = (e) => {
		e.preventDefault();
		let menu = $('.js-mobile-nav-toggle');
		if (menu.hasClass('mobile-nav--close')) {
			menu.click();
		}
		let searchSection = $('.search-section');
		searchSection.slideToggle();
		//searchSection.find("input.input.search-input").focus();
		setTimeout(function() {
			searchSection.find("input.input.search-input").focus();
		}, 500);
		/*if ($(window).width() < 1300) {
			menu.slideToggle();
			$('.hamburger').removeClass('active');
			if (menu.hasClass('active')) {
				menu.removeClass('active');
				searchSection.slideDown();
			} else {
				menu.addClass('active');
			}
		}*/
	}

  let closeSearchDiv = (e) => {
		e.preventDefault();
    let menu = $('.menu');
		let searchSection = $('.search-section');
		let body = $('body');
		searchSection.slideToggle();
		//searchSection.find("input.input.search-input").focus();


		if (body.hasClass('boost-pfs-search-suggestion-mobile-open')) {
			let suggestions = $('.boost-pfs-search-suggestion-mobile');
			let suggestionsOverlay = $('.boost-pfs-search-suggestion-mobile-overlay');
			suggestions.hide();
			suggestionsOverlay.hide();
			body.removeClass('boost-pfs-search-suggestion-mobile-open');
		}
	}


	let toggleMenuBar = (e) => {
		if ($(e.currentTarget).siblings().length > 0) {
			e.preventDefault();
			if ($(e.currentTarget).hasClass('nav__link--sub-nav-mobile-open')) {
				$(e.currentTarget).find('.nav-bar__sub-link-section').toggleClass('active');
				$(e.currentTarget).parents('.nav__item').find('.nav-bar__sub-list').addClass('active');
			}
			$(e.currentTarget).toggleClass('active');
			$(e.currentTarget).parents('.nav__item').find('.nav-bar').slideToggle();
		}
	}

	let toggleMenuSubBar = (e) => {
		if ($(e.currentTarget).siblings().length > 0) {
			e.preventDefault();
			$(e.currentTarget).toggleClass('active');
			$(e.currentTarget).parents('.nav-bar__item').find('.nav-bar__sub-list').slideToggle();
		}
	}

	let animateLogo = (e) => {
		$(window).scrollTop() > 0 
			? $('.header').addClass('header--scroll')
			: $('.header').removeClass('header--scroll');
	}

	let animateDualLogo = (e) => {
		$(window).scroll(function(){
			if ($(this).scrollTop() > 100) {
				$(".dual-hero__logo").css({"opacity" : "0"})
			}
			else {
				$(".dual-hero__logo").css({"opacity" : "1"});
				if ($(window).width() < 991) {
					$(".dual-hero__list--slider").slick('slickPlay');
				}
			}
		});


	    $(window).scroll(function(){
	        if ($(window).scrollTop() > $(window).height()/2) {
	            $('.sticky-bar').show();
	        }
	        else {
	            $('.sticky-bar').hide();
	        }
	    });

	}

	let addMenuItemParentClass = () => {
		$('.nav-bar__sub-link-section:contains("#")').parents('.nav-bar__item').addClass('nav-bar__item--hash');

		let navBarLists = $('.nav-bar__list');
		for (let i = 0; i < navBarLists.length; i++) {
			let navBarList = navBarLists[i];
			let navBarItems = $(navBarList).find('.nav-bar__item--no-child');
			navBarItems.wrapAll('<ul class="nav-bar__list--no-child">');
		}

		$('.list__item--large').parent('.list').addClass('list--large');
	}

	let addLifestyleSliderParentClass = () => {
		if ($('#shopify-section-product-lifestyle').children().length > 0) {
			$('.template-product').addClass('template-product--with-lifestyle-slider');
		}
	}

	let addProductTabsParentClass = () => {
		let availabilityTab = $('.tabs__headings-link:contains("Availability")');
		let availabilityTabIndex = $('.tabs__headings-link').index(availabilityTab);

		availabilityTab.parents('.tabs').addClass('tabs--with-availability');

		if ($(window).width() > 992) {
			$('.product-tabs--desktop .tabs--with-availability').find('.tabs__body-item').eq(availabilityTabIndex).addClass('tabs__body-item--availability');
		} else {
			availabilityTabIndex = availabilityTabIndex + 1;
			$('.product-tabs--mobile .tabs--with-availability').find('.tabs__body-item').eq(availabilityTabIndex).addClass('tabs__body-item--availability');
		}
	}

	let changeProductTabsText = () => {
		$('.product-tabs--reverse').parents('.shopify-section').find('.product-tabs--desktop .tabs__headings-link:contains("DETAILS")').text('DESCRIPTION');
	}

	let addProductPageAnnouncementClass = () => {
		let templateProduct = $('body.template-product');
		let templateCollection = $('body.template-collection');
		let templateSearch = $('body.template-search');
		let headerSection = $('.header-section');
		if ( headerSection.hasClass('header-section--announcement-bar') && !headerSection.hasClass('header-section--announcement-bar-homepage-only') ) {
			templateProduct.addClass('template-product--announcement-bar');
			templateCollection.addClass('template-collection--announcement-bar');
			templateSearch.addClass('template-search--announcement-bar');
		}
	}

	let addFilterUnderlines = (e) => {
		if ($(window).width() < 767) {
			$('.boost-pfs-filter-option').removeClass('active');
			$(e.currentTarget).addClass('active');
			return
		}
	}

	let initHeroSlider = () => {
		if ($('.hero-slider .slider').length > 0) {
			$('.hero-slider .slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				autoplay: true,
  				autoplaySpeed: 6500,
				pauseOnHover: false,
				pauseOnFocus: false,
				speed: 1500
			});
		}
	}

	let initExploreSlider = () => {
		if ($('.explore__list--slider').length > 0) {
			$('.explore__list--slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<div class="prev-arrow"><svg class="svg-arrow" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.14527e-08 5.15332L5.15381 8.43126e-09L5.86084 0.707031L1.41406 5.15332L5.86084 9.6001L5.15381 10.3071L6.14527e-08 5.15332Z" fill="black"/></svg></div>',
	      nextArrow: '<div class="next-arrow"><svg class="svg-arrow" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.86084 5.84668L0.707031 11L-3.09053e-08 10.293L4.44678 5.84668L-4.19634e-07 1.3999L0.707031 0.692871L5.86084 5.84668Z" fill="black"/></svg></div>',
				speed: 1000
			});
		}
	}

	let initCardImgSlider = () => {
		if ($('.card__picture--slider .grid-view-item__slider-wrapper').length > 0) {
			$('.card__picture--slider .grid-view-item__slider-wrapper').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				//autoplay: true,
				arrows: true,
				dots: false,
				adaptiveHeight: false,
				prevArrow: '<div class="prev-arrow"><svg class="svg-arrow" width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.12695 16.3481L0.290834 8.51202M8.12695 1.12406L0.663983 8.58703" stroke="black" stroke-opacity="0.88" stroke-width="0.791568"/></svg></div>',
	      nextArrow: '<div class="next-arrow"><svg class="svg-arrow" width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.873047 1.12415L8.70917 8.96027M0.873047 16.3482L8.33602 8.88526" stroke="black" stroke-opacity="0.88" stroke-width="0.791568"/></svg></div>'
			});
		}
	}

	let initFeaturedCollectionSlider = () => {
		if ($('.featured-collection .slider').length > 0) {
			let slider = $('.featured-collection .slider'),
				slider_settings = {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					dots: true,
					adaptiveHeight: true
				}
			
			$(window).on('load resize', () => {
				if ($(window).width() > 992) {
					if (slider.hasClass('slick-initialized')) {
						slider.slick('unslick');
					}
					return
				}
				if (!slider.hasClass('slick-initialized')) {
					return slider.slick(slider_settings);
				}
			});
		}
	}
	let initDoubleHeroSlider = () => {
		if ($('.dual-hero__list--slider').length > 0) {
			let slider = $('.dual-hero__list--slider'),
				slider_settings = {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: false,
					pauseOnFocus: false,
					pauseOnHover: false,
					autoplay: true,
					fade: true,
  					cssEase: 'linear',
  					autoplaySpeed: 2000,
					adaptiveHeight: true
				}
			
			$(window).on('load resize', () => {
				if ($(window).width() > 992) {
					if (slider.hasClass('slick-initialized')) {
						slider.slick('unslick');
					}
					return
				}
				if (!slider.hasClass('slick-initialized')) {
					return slider.slick(slider_settings);
				}
			});
		}
	}

	let initDoubleHeroSliderDesk = () => {
	    if ($('.dual-hero__item--container').length > 0) {
	      let slider = $('.dual-hero__item--container'),
	        slider_settings = {
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          infinite: true,
	          arrows: false,
	          dots: false,
	          pauseOnFocus: false,
	          pauseOnHover: false,
	          autoplay: true,
	          fade: true,
	          cssEase: 'linear',
	          autoplaySpeed: 2000,
	          adaptiveHeight: true
	        }

	      if (!slider.hasClass('slick-initialized')) {
	        return slider.slick(slider_settings);
	      }
	    }
	  }


	let initHalfSlider = () => {
		let slider = $('.half-slider__slider'),
			slider_settings = {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				dots: false,
				pauseOnFocus: false,
				pauseOnHover: false,
				autoplay: true,
				fade: true,
					cssEase: 'linear',
					autoplaySpeed: 2000,
				adaptiveHeight: true
			}
			if (!slider.hasClass('slick-initialized')) {
				return slider.slick(slider_settings);
			}
	}
	let initLifestyleSlider = () => {
		if ($('.lifestyle-slider .slider').length > 0) {
			let slider = $('.lifestyle-slider .slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				variableWidth: true,		
				adaptiveHeight: true
			});

			let sliderImage = $('.lifestyle-slider__image');
			let sliderDots = $('.lifestyle-slider .slick-dots');

			$(window).on('load resize', () => {
				if ($(window).width() < 993) {
					sliderDots[0].style.top = sliderImage[0].clientHeight - 3 + 'px';
					return
				}
			});
		}
	}

	let initMGIRLSlider = () => {
	    if ($('.episode-one__slider.slider').length > 0) {
	      $('.episode-one__slider.slider').slick({
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        arrows: true,
	        dots: true,
	        prevArrow: $('.episode-one__arrow--prev'),
	        nextArrow: $('.episode-one__arrow--next'),
	        // autoplay: true,
	        // autoplaySpeed: 6500,
	        speed: 500
	      });
	    }
	  }
  
	let initOurStorySlider = () => {
		if ($('.our-offerings__list').length > 0) {
			let slider = $('.our-offerings__list').not('.slick-initialized').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				variableWidth: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							dots: false,
							arrows: true,
							fade: false
						}
					}
				]
			});
		
			slider.on('wheel', ((e) => {
				if (e.originalEvent.wheelDeltaX < -10) {
					$(slider).slick('slickNext');
				}
				else if (e.originalEvent.wheelDeltaX > 10) {
					$(slider).slick('slickPrev');
				}
			}));
		}
	}

	let initPromoProductsSlider = () => {
		if ($('.promo-products .slider').length > 0) {
			$('.promo-products .slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				fade: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							dots: true,
							arrows: false,
							fade: false
						}
					}
				]
			});

			/*$('.promo-products .slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				fade: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							dots: false,
							arrows: false,
							slide: '.promo-products .slide',
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							centerPadding: '10px',
							fade: false
						}
					}
				]
			});*/

			$('.promo-products .arrow--prev').on('click', (e) => {
				e.preventDefault();
				$('.promo-products .slider').slick('slickPrev');
			});

			$('.promo-products .arrow--next').on('click', (e) => {
				e.preventDefault();
				$('.promo-products .slider').slick('slickNext');
			});
		}
	}

	let initLandingSlider = () => {
		if ($('.s-s-landing-page__slider').length > 0) {
			$('.s-s-landing-page__slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				autoplay: true,
  				autoplaySpeed: 4000,
				pauseOnHover: false,
				pauseOnFocus: false,
				speed: 1500,
				vertical: true,
  				verticalSwiping: true
			});
		}
	}
	let initInspiredSapphires = () => {
		if ($('.inspired-sapphires-slider').length > 0) {
			$('.inspired-sapphires-slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				autoplay: false,
  				autoplaySpeed: 4000,
				pauseOnHover: false,
				pauseOnFocus: false,
				 rows: 0,
				speed: 1500
			}).on('setPosition', function (event, slick) {
			slick.$slides.css('height', slick.$slideTrack.height() + 'px');
		});
		}
	}


	let initProductSlider = () => {
		if ($('.product__slider').length > 0) {
			$('.product__slider').not('.product__slider--single, .slick-initialized, .product__slider-new').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				draggable: false,
				slide: '.product-template-single__slide',
				asNavFor: '.product__slider--nav',
				responsive: [
					{
					  breakpoint: 991,
					  settings: {
						asNavFor: null,
						draggable: true,
						dots: true
					  }
					}
				  ]
			});
			$('.product__slider--nav').not('.slick-initialized').slick({
				slidesToShow: 11,
				slidesToScroll: 1,
				vertical: true,
				verticalSwiping: true,
				focusOnSelect: true,
				slide: '.product__slider--thumbnails',
				asNavFor: '.product__slider',
				responsive: [
					{
					  breakpoint: 991,
					  settings: 'unslick'
					}
				  ]
			});
		}
	}

  let initProductDescription = () => {
		if ($(window).width() < 991 && $('.product__description--show-on-mobile').length > 0) {
      if ($('.product__description--show-on-mobile').height() > 100) {
        $('.product__description--show-on-mobile').addClass('product__description--more');
        $('.product__description--show-on-mobile').after(`
          <button class="product__description-read-more" style="margin-top: 15px;">Read more</button>
        `);

        $('.product__description-read-more').click(function() {
          if ($('.product__description--show-on-mobile').hasClass('product__description--more')) {
            $('.product__description--show-on-mobile').removeClass('product__description--more');
            $('.product__description-read-more').text('Read less');
          } else {
            $('.product__description--show-on-mobile').addClass('product__description--more');
            $('.product__description-read-more').text('Read more');
          }
        })
      }
		}
	}

  let toggleProductSlider = (e) => {
    if ($(window).width() > 992 && $('.product-slider-full-width').length > 0) {
    	if (!$(e.target).hasClass('plyr__control')) {
	      $('.product-slider-full-width').toggleClass('hide');

	      let currImg = $(e.currentTarget).find('.feature-row__image');
	      let slickSlideGoTo = [];
	      
	      if (currImg != undefined) {
	        document.querySelectorAll('.product-slider-full-width__inner .product-slider-full-width__img').forEach((element) => {
	        	if (element.classList.contains('media-video')) {
		          if (element.getAttribute('poster').includes(currImg.attr('poster'))) {
		            slickSlideGoTo.push(element.closest('.product-slider-full-width__slide').dataset.slickIndex);
		          }
	        	} else {
		          if (element.getAttribute('src').includes(currImg.attr('src'))) {
		            slickSlideGoTo.push(element.closest('.product-slider-full-width__slide').dataset.slickIndex);
		          }
		        }
	        });
			$('.product-slider-full-width__inner').slick('unslick');
			initProductVerticalSlider();
	        $('.product-slider-full-width__inner').slick('slickGoTo', slickSlideGoTo[0]);
	      }
	    }
    }
	}

  let initProductVerticalSlider = () => {
    if ($('.product-slider-full-width__inner').length > 0) {
      $('.product-slider-full-width__inner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        draggable: true,
        dots: false,
        slide: '.product-slider-full-width__slide',
      });
    }

		if ($('.product__slider-new').length > 0) {
			$('.product__slider-new').not('.product__slider--single, .slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				draggable: true,
        dots: true,
				slide: '.product-template-single__slide',
        mobileFirst: true,
				responsive: [
					{
            breakpoint: 992,
            settings: "unslick"
					}
				]
			});

      if ($(window).width() > 992 && $('.product-single .product__content').length > 0) {
        (function () {
          var a = document.querySelector('.product-single .product__content'), b = null, P = 51;
          window.addEventListener('scroll', Ascroll, false);
          document.body.addEventListener('scroll', Ascroll, false);
          window.addEventListener('click', Ascroll, false);
          document.body.addEventListener('click', Ascroll, false);
          function Ascroll() {
            if (b == null) {
              var Sa = getComputedStyle(a, ''), s = '';
              for (var i = 0; i < Sa.length; i++) {
                if (Sa[i].indexOf('overflow') == 0 || Sa[i].indexOf('padding') == 0 || Sa[i].indexOf('border') == 0 || Sa[i].indexOf('outline') == 0 || Sa[i].indexOf('box-shadow') == 0 || Sa[i].indexOf('background') == 0) {
                  s += Sa[i] + ': ' + Sa.getPropertyValue(Sa[i]) + '; '
                }
              }
              b = document.createElement('div');
              b.style.cssText = s + ' box-sizing: border-box; width: ' + a.offsetWidth + 'px;';
              a.insertBefore(b, a.firstChild);
              var l = a.childNodes.length;
              for (var i = 1; i < l; i++) {
                b.appendChild(a.childNodes[1]);
              }
              a.style.height = b.getBoundingClientRect().height + 'px';
              a.style.padding = '0';
              a.style.border = '0';
            }
            var Ra = a.getBoundingClientRect(),
              R = Math.round(Ra.top + b.getBoundingClientRect().height - document.querySelector('.product__media-wrapper').getBoundingClientRect().bottom);
            if ((Ra.top - P) <= 0) {
              if ((Ra.top - P) <= R) {
                b.className = 'stop';
                b.style.top = - R + 'px';
              } else {
                b.className = 'sticky';
                b.style.top = P + 'px';
              }
            } else {
              b.className = '';
              b.style.top = '';
            }
            window.addEventListener('resize', function () {
              a.children[0].style.width = getComputedStyle(a, '').width
            }, false);
          }
        })()
      }
    }
  }
	
	let mousemoveTextFeaturedCollection = (e) => {
		if ($(e.currentTarget).find('.card__hover').length > 0) {

			let element = $(e.currentTarget).find('.card__hover'),
				rect = e.currentTarget.getBoundingClientRect(),
				x = e.clientX - rect.left,
				y = e.clientY - rect.top,
				newposX = x - (element.width() / 2),
				newposY = y - (element.height());
			
			$(e.currentTarget).find('.card__hover').css('transform', 'translate3d(' + newposX + 'px,' + newposY + 'px, 0px)');
		}
	}

	let loadFilter = () => {
		if ($(window).width() < 768) {
			let filters = [];
			let filtersString = '';

			let timerId = setInterval(() => {
				if ($('.boost-pfs-filter-option').length > 0) {
					clearInterval(timerId);

					$('.boost-pfs-filter-option').each(function(i, el) {
						if ($(el).find('.boost-pfs-filter-selected-items-mobile span').length > 0) {
							filters.push($(el).find('.boost-pfs-filter-selected-items-mobile span').html());
						}
					});

					filtersString = filters.join(', ');

					if (filtersString) {
						$('.bar__applied-filters-list').text(': ' + filtersString);
					}
					else {
						$('.bar__applied-filters-list').text(', NONE');
					}
				}
			}, 500);

			// fix troubles with forward/backward browser buttons
			let timerId2 = setInterval(() => {
				let param = localStorage.getItem('filterParam');

				if (!param) {
					localStorage.setItem('filterParam', window.location.href);
				}

				if (localStorage.getItem('filterParam') != window.location.href) {
					clearInterval(timerId2);
					localStorage.removeItem('filterParam');
					loadFilter();
				}
			}, 500);
		}
	}

	let toggleFooterAccordeon = (e) => {
		if ($(window).width() < 993) {
			$('.footer__column--menu .footer__content').slideUp();
			if ($(e.currentTarget).next('.footer__content').css('display') == 'none') {
				$(e.currentTarget).next('.footer__content').slideDown();
			}
		}
	}

  let toggleMobHeaderAccordeon = (e) => {
    if ($(window).width() < 993) {
      let currIndex = e.currentTarget.dataset.target;
      $(e.currentTarget).find('.mobile-nav__icon').toggleClass('mobile-nav__icon--active')
      $(`.mobile-nav__dropdown-second[data-parent="${currIndex}"]`).slideUp();
      if ($(`.mobile-nav__dropdown-second[data-parent="${currIndex}"]`).css('display') == 'none') {
        $(`.mobile-nav__dropdown-second[data-parent="${currIndex}"]`).slideDown();
      }
    }
  }

	let toggleAccordeon = (e) => {
			$(e.currentTarget).next('.accordeon__content').slideUp();
			$(e.currentTarget).removeClass('active');
			if ($(e.currentTarget).next('.accordeon__content').css('display') == 'none') {
				$(e.currentTarget).next('.accordeon__content').slideDown();
				$(e.currentTarget).addClass('active');
			}
	}
	let toggleSeason = (e) => {
		$(e.currentTarget).next('.season-episodes__list').slideUp();
		$(e.currentTarget).removeClass('active');
		if ($(e.currentTarget).next('.season-episodes__list').css('display') == 'none') {
			$(e.currentTarget).next('.season-episodes__list').slideDown();
			$(e.currentTarget).addClass('active');
		}
}

	let toggleAccordeonClose = (e) => {
		$(e.currentTarget).parents('.accordeon').find('.accordeon__content').slideUp();
		$(e.currentTarget).parents('.accordeon').find('.accordeon__header').removeClass('active');
	}
	let toggleAccordeonDelete = (e) => {
		$(e.currentTarget).parents('.accordeon').slideUp(300, function() {$(this).remove();});
	}

	let initProductOptions = () => {
		let options = $('.product .product-form__item').find('.options');

		options.each((i, option) => {
			let select = $(option).parent().find('.single-option-selector');
			let selectedOptionValue = select.val();

			let optionItems = $(option).find('.options__item');

			optionItems.each((i, optionItem) => {
				let optionValue = $(optionItem).find('.options__value').text();

				if (optionValue == selectedOptionValue) {
					$(option).find('.options__item').removeClass('active');
					$(optionItem).addClass('active');
				}
			});
		});

    //display metal text
    if ($('[data-option="metal"] .single-option-selector--size').length > 0) {
      let newSelectedValue = $('[data-option="metal"] .single-option-selector--size').find(":selected").text();
      $('[data-option="metal"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
      $('.options__item--global-color').removeClass('active');
      $('.options__item--global-color[data-color="'+ newSelectedValue +'"]').addClass('active');
    }
    //display length text
    if ($('[data-option="length"] .single-option-selector--size').length > 0) {
      let newSelectedValue = $('[data-option="length"] .single-option-selector--size').find(":selected").text();
      $('[data-option="length"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
      $('.options__item--global-color').removeClass('active');
      $('.options__item--global-color[data-color=\''+ newSelectedValue +'\']').addClass('active');
    }
    //display color text
    if ($('[data-option="color"] .single-option-selector--size').length > 0) {
      let newSelectedValue = $('[data-option="color"] .single-option-selector--size').find(":selected").text();
      $('[data-option="color"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
      $('.options__item--global-color').removeClass('active');
      $('.options__item--global-color[data-color="'+ newSelectedValue +'"]').addClass('active');
    } 

    //display size text
    if ($('[data-option="size"] .single-option-selector--size').length > 0) {
      let newSelectedValue = $('[data-option="size"] .single-option-selector--size').find(":selected").text();
      $('[data-option="size"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
    }
	}

	let changeProductOptions = (e) => {
		e.preventDefault();

		let newSelectedValue = $(e.currentTarget).find('.options__value').text();

		// remove from all option items active class and set to the current item
		$(e.currentTarget).parents('.options').find('.options__item').removeClass('active');
		$(e.currentTarget).parents('.options__item').addClass('active');
		
		// change select value on default select
		let select = $(e.currentTarget).parents('.options').parent().find('.single-option-selector');
		select.val(newSelectedValue);

		// imitate change event for default select
		const event = document.createEvent('HTMLEvents');
		event.initEvent('change', false, true);
		select[0].dispatchEvent(event);

    const opotion = select.parent().find('.product-form__option-name')[0].innerText.toLowerCase().replace(/\s/g,'');

    //display metal text
    if (opotion == 'metal' || opotion == 'color') {
      $('[data-option="'+opotion+'"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
      $('.options__item--global-color').removeClass('active');
      $('.options__item--global-color[data-color="'+ newSelectedValue +'"]').addClass('active');
    }

    //display size
    if (opotion == 'size' || opotion == 'length') {
      $('[data-option="'+opotion+'"] .product-form__option-selected-value--size')[0].innerHTML = newSelectedValue;
    }

    //scroll to image
    let selectorWrapper = e.currentTarget.closest('.selector-wrapper');
    if (($('.product__slider-new').length > 0) ) {
      let variantSelected = $('.product-form__variants').find(':selected')[0];
      if ($(window).width() > 991){
        document.querySelectorAll('.product__slider-new picture .product-featured-media').forEach((element) => {
          if (element.getAttribute('src').includes(variantSelected.dataset.image)) {
            const y = element.getBoundingClientRect().top + window.scrollY - 50;
            window.scroll({
              top: y,
              behavior: 'smooth'
            });
          }
        });
      } else {
        let slickSlideGoTo = [];
        document.querySelectorAll('.product__slider-new picture .product-featured-media').forEach((element) => {
          if (element.getAttribute('src').includes(variantSelected.dataset.image)) {
            slickSlideGoTo.push(element.closest('.product-single__media-wrapper').dataset.slickIndex);
          }
        });
        $('.product__slider-new').slick('slickGoTo', slickSlideGoTo[0]);
      }
    }
	}

  let openSizePopup = (e) => {
		e.preventDefault();
		var option = $(e.target).closest(".options--size-value").data('option');
    $('[data-option="'+ option +'"] .options__popup').removeClass('options__popup--close');
	}

  let closeSizePopup = (e) => {
		e.preventDefault();
    $('.options__popup').addClass('options__popup--close');
	}

	let disableScrolling = () =>{
		    var x=window.scrollX;
		    var y=window.scrollY;
		    window.onscroll=function(){window.scrollTo(x, y);};
		}

	let  enableScrolling = () => {
		    window.onscroll=function(){};
		}
  let openProductPopup = (e) => {
		e.preventDefault();
    e.currentTarget.nextElementSibling.classList.remove('product-info-bottom__popup--close');
    $('body').addClass('stop-scrolling');
    disableScrolling();
	}

  let closeProductPopup = (e) => {
		e.preventDefault();
    e.currentTarget.parentNode.parentNode.parentNode.classList.add('product-info-bottom__popup--close');

		setTimeout(function() {
			$('body').removeClass('stop-scrolling');
			enableScrolling();
		}, 500);
	}

	let toggleProductNotes = (e) => {
		/*	e.preventDefault();
		console.log(e.currentTarget.classList);
    $(e.currentTarget).toggleClass('active');*/

		e.preventDefault();
    const clickedElement = e.target;
    const container = e.currentTarget;
		if (clickedElement.classList.contains("product_notes-title")) {
			$(container).toggleClass('active');
    } 
	}

	let toggleProductTabs = (e) => {
		e.preventDefault();

		let tabblock = $(e.currentTarget).parents('.tabs');
		let index = $(e.currentTarget).parents('.tabs__headings-item').index();
		// toggle headings
		if ($(e.currentTarget).parents('.tabs__headings-item').hasClass('active')) {
			$(e.currentTarget).parents('.tabs__headings-item').removeClass('active')
		}
		else {
			tabblock.find('.tabs__headings-item').removeClass('active');
			$(e.currentTarget).parents('.tabs__headings-item').addClass('active')
		}

		// toggle contents
		if (tabblock.find('.tabs__body-item').eq(index).hasClass('active')) {
			tabblock.find('.tabs__body-item').removeClass('active')
		}
		else {
			tabblock.find('.tabs__body-item').removeClass('active');
			tabblock.find('.tabs__body-item').eq(index).addClass('active');
		}
		
	}

	let toggleProductBlockTabs = (e) => {
		e.preventDefault();
		let error_required = '0';

		if ($(e.currentTarget).parents('.custom-engagement-form').length) {
			error_required = requiredFieldsBridal(6);
		}
		if (error_required != 1) {
			let tabblock = $(e.currentTarget).parents('.tabs');
			
			// toggle collection title
			tabblock.find('.tabs__headings-item').removeClass('active');
			$(e.currentTarget).parents('.tabs__headings-item').addClass('active');

			// toggle collection products
			tabblock.find('.tabs__body-item').removeClass('active');
			let index = $(e.currentTarget).parents('.tabs__headings-item').index();
			
			tabblock.find('.tabs__body-item').eq(index).addClass('active');
			//$('.tabs__body-item').eq(index).addClass('active');
		}
	}

	let toggleEngagementFormInput = (e) => {
		$('#write_your_preferred_cut_here').toggleClass('hide');
	}

	let showLandingEmailForm = (e) => {
		e.preventDefault();
		$('.container-main').hide();
		$('.block-empty').show();
		$('.container-form').css('display', 'flex');
		$('.s-s-landing-page__slider').addClass('s-s-landing-page__slider--blur');
	}

	let hideLandingEmailForm = () => {
		$('.block-empty').hide();
		$('.container-form').hide();
		$('.container-main').show();
		$('.s-s-landing-page__slider').removeClass('s-s-landing-page__slider--blur');
	}

	let removeBlurLandingEmailForm = () => {
		let containerForm = $('.container-form');
		setTimeout(function(){
			if ($(window).width() > 767) {
				if(containerForm.find('input.kl-private-reset-css-Xuajs1').length < 1) {
					setTimeout(function() {
						$('.block-empty').hide();
						containerForm.hide();
						$('.container-main').show();
						$('.s-s-landing-page__slider').removeClass('s-s-landing-page__slider--blur');
					}, 5000);
				}
			} else {
				if(containerForm.find('input.kl-private-reset-css-Xuajs1').length < 2) {
					setTimeout(function() {
						$('.block-empty').hide();
						containerForm.hide();
						$('.container-main').show();
						$('.s-s-landing-page__slider').removeClass('s-s-landing-page__slider--blur');
					}, 5000);
				}
			}
		}, 1500);
	}

	let toggleButtonTab = (e) => {
		e.preventDefault();
		let error_required = '0';
		if ($(e.currentTarget).parents('.custom-engagement-form').length) {
			error_required = requiredFieldsBridal(6);
		}
		if (error_required != 1) {
			let tabblock =  $(e.currentTarget).parents('.tabs');
			
			tabblock.find('.tabs__headings-item').removeClass('active');

			tabblock.find('.tabs__body-item').removeClass('active');
			let index = $(e.currentTarget).parents('.tabs__body-item').index() + 1;
			
			tabblock.find('.tabs__body-item').eq(index).addClass('active');
			tabblock.find('.tabs__headings-item').eq(index).addClass('active');
			let tablink = tabblock.find('.tabs__headings-item').eq(index);
			if (tablink.find('.tabs__headings-link').hasClass('multi__content')){

				toggleScreenRevers(tablink.find('.tabs__headings-link'));
			}
			$('html, body').animate({scrollTop : 0},300);
		}
	}

	let toggleBackButtonTab = (e) => {
		e.preventDefault();

		let tabblock =  $(e.currentTarget).parents('.tabs');
		
		tabblock.find('.tabs__headings-item').removeClass('active');

		tabblock.find('.tabs__body-item').removeClass('active');
		let index = $(e.currentTarget).parents('.tabs__body-item').index() - 1;
		
		tabblock.find('.tabs__body-item').eq(index).addClass('active');
		tabblock.find('.tabs__headings-item').eq(index).addClass('active');
	}

	let toggleBackButtonTabForm = (e) => {
		e.preventDefault();

		let tabblock =  $(e.currentTarget).parents('.show-hide');
		tabblock.hide();

		tabblock.prev().show();
	}

	let toggleBackButtonTabEducationForm = (e) => {
		e.preventDefault();

		let tabblock =  $(e.currentTarget).parents('.tabs');
		let index = $(e.currentTarget).parents('.tabs__body-item').index() - 1;
		
		tabblock.find('.tabs__headings-item').removeClass('active');
		tabblock.find('.tabs__body-item').removeClass('active');

		tabblock.find('.tabs__headings-item').eq(index).addClass('active');
		tabblock.find('.tabs__body-item').eq(index).addClass('active');
	}

	let toggleScreenRevers = (e) => {

		$('.screen').each(function(i) {
			if (i <= 1){
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	}

	let toggleScreen = (e) => {
		e.preventDefault();

		let indexscreen = $(e.currentTarget).parents('.screen').index();
		
		$('.screen').each(function(i) {
			if ((indexscreen < i) && (i <= indexscreen+2)) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		
	}
	let toggleMobSubNav = (e) => {
		$('.block-sub-menu').toggleClass('show');
		$(e.currentTarget).toggleClass('open');
	}

	let togglePopupWindow = (e, method) => {
		/* Modal Popup */
		// method 'open'				- click on action button
		// method 'mouseClose'	- click on close button
		// method 'keyClose'		- keydown on ESC
		// data-modal-trigger		- button witch open popup. Attr must have popup id [data-modal-trigger="dropHint"]
		// data-modal-name			- write pupup id [data-modal-name="dropHint"]
		// data-modal-dismiss		- elements, witch closed popup
		if (!$('[data-modal-name]').length == 0) {
			switch (method) {
				case 'open':
					e.preventDefault();
					let modalId = $(e.currentTarget).attr('data-modal-trigger');
					$('[data-modal-name="' + modalId + '"]').addClass('is-modal-active');
					$('body').addClass('popup-open');
					break;
				case 'mouseClose':
					e.preventDefault();
					$(e.currentTarget).parents('.popup').removeClass('is-modal-active');
					$('body').removeClass('popup-open');
					break;
				case 'keyClose':
					if (e.keyCode === 27) { // ESC
						$('.popup').removeClass('is-modal-active');
						$('body').removeClass('popup-open');
					}
					break;
			}
		};
	}

	let deleteAccountAddress = (e) => {
		let addressId = parseInt($(e.currentTarget).attr('data-target'))
		let confirmMessage = parseInt($(e.currentTarget).attr('data-confirm-message'));
		if (
			confirm(
			confirmMessage || 'Are you sure you wish to delete this address?'
			)
		) {
			$.ajax({
				type: 'POST',
				url: '/account/addresses/' + addressId,
				dataType: 'json',
				data: {
					_method: 'delete'
				}
			}).done(function(data) {
				toggleAccordeonDelete(e);
			}).fail(function(errMsg) {
				/*  first time status: 302 is returned, and then status: 200. Status: 302 is not an error, but not a success. Therefore, it throws it into a feil and returns stauts 200*/
				if (errMsg.status == 200) {
					toggleAccordeonDelete(e);
				} else {
					alert('Unfortunately, it was not possible to delete. Try later.')
				}
			})
		}
	}

	let cloneInput = (e) => {
		if ($(e.currentTarget).attr('name') == 'first_name_clone'){
			$('#first_name').val($(e.currentTarget).val());
		}
		if ($(e.currentTarget).attr('name') == 'last_name_clone'){
			$('#last_name').val($(e.currentTarget).val());
		}
		if ($(e.currentTarget).attr('name') == 'email_clone'){
			$('#email').val($(e.currentTarget).val());
		}
		if ($(e.currentTarget).attr('name') == 'phone_clone'){
			$('#phone_number').val($(e.currentTarget).val());
		}
	}

	let requiredFieldsBridal = (e) => {
		error = '0';
		if (e > 0) {
			for(let j=0; j < e; j++){
				let divid = 'div' + j;
				let formtab = document.getElementById(divid);
				if (formtab == null) {
					return error;
				}
				let inputs = formtab.querySelectorAll("input");
				for(let i=0; i < inputs.length; i++){
					if (inputs[i].type == 'email'){
						if (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(inputs[i].value)) {
							inputs[i].style.borderColor = 'transparent';
						} else {
							inputs[i].style.border = "1px solid red";
							if (errortext == '0') {
								let z = document.createElement('span'); 
								z.innerHTML = 'Please fill all the required fields.';
								document.querySelector('.success-err-msg').appendChild(z);
								errortext = 1;
							}
							error = 1;
						}

					} else if (inputs[i].type == 'tel') {
						if (/^(\+)?(\(\d{2,3}\) ?\d|\d)(([ \-]?\d)|( ?\(\d{2,3}\) ?)){8,12}\d$/i.test(inputs[i].value)) {
							inputs[i].style.borderColor = 'transparent';
						} else {
							inputs[i].style.border = "1px solid red";
							if (errortext == '0') {
								let z = document.createElement('span'); 
								z.innerHTML = 'Please fill all the required fields.';
								document.querySelector('.success-err-msg').appendChild(z);
								errortext = 1;
							}
							error = 1;
						}
						
					} else {
						if (inputs[i].id == 'zip_code') {
							if (/(^\d{5}$)|(^\d{5}-\d{4}$)/i.test(inputs[i].value)) {
								inputs[i].style.borderColor = 'transparent';
							} else {
								inputs[i].style.border = "1px solid red";
								if (errortext == '0') {
									let z = document.createElement('span'); 
									z.innerHTML = 'Please fill all the required fields.';
									document.querySelector('.success-err-msg').appendChild(z);
									errortext = 1;
								}
								error = 1;
							}
						} else if(inputs[i].value === '' && inputs[i].hasAttribute('required')){
							inputs[i].style.border = "1px solid red";
							if (errortext == '0') {
								let z = document.createElement('span'); 
								z.innerHTML = 'Please fill all the required fields.';
								document.querySelector('.success-err-msg').appendChild(z);
								errortext = 1;
							}
							error = 1;
						} else {
							inputs[i].style.borderColor = 'transparent';
						}
					}
				}
				if (error == 0 && errortext == '1') {
					document.querySelector('.success-err-msg span').remove();
					errortext = 0;
				}
				if (error == '1') {
						index = j;
						return error;
						break;
				}
			}
		}


	}

	let addCustomTitleToCollectionFilter = (e) => {
		if ($('.boost-pfs-filter-options-wrapper').length) {
			let titleBlockClass = 'boost-pfs-filter-option-tab-title';
			$('.'+titleBlockClass).remove();
      let extendedContentList = $('.boost-pfs-filter-options-wrapper').children('.boost-pfs-filter-option-list');
      for (let option of extendedContentList) {
				let tabTitle = $(option).find('.boost-pfs-filter-option-title-text').html();
				$(option).find('.boost-pfs-filter-option-content-inner').prepend('<div class="'+titleBlockClass+'">'+tabTitle+'</div>');
				var ariaLabel = $(option).find('.boost-pfs-filter-option-title-heading')[0].ariaLabel
				option.ariaLabel = ariaLabel
  		}
		} 
	}
  
	let changeRoleSearchPopup = (e) => {
		if ($('#ui-id-1').length) {
			$('#ui-id-1').attr( 'role','search results displayed');
		}
	}
	let toggleCollectionFirstItem =(e) => {
		if ($('.boost-pfs-filter-options-wrapper').length) {
			$('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option:first-child .boost-pfs-filter-option-title-heading').trigger( "click" );
		}
	}

	let closeCollectionFilter =(e) => {
		if ($('.boost-pfs-filter-options-wrapper').length && $('.boost-pfs-filter-tree-mobile-open').length ) {
      $('.boost-pfs-filter-tree-mobile-button > button').trigger('click');
		}
	}

	let csCustomForm = (e) => {
		e.preventDefault();  
		$('.element-group input').hide(); 
		$('.element-group input').removeAttr('required');
		$('.element-group input[name=email_clone]').remove();
		$('.ring_shape').hide();
		$('.form-submit-btn-wrap').hide();

	}

	let toggleContactFormDatepicker = (e) => {
		if ($(e.currentTarget).val() == "Fine Jewelry Appointment" || $(e.currentTarget).val() == "Timepiece Appointment") {
			$('.cs-datepicker--contact-form').removeClass('hide');
		} else {
			$('.cs-datepicker--contact-form').addClass('hide');
		}
		if ($(e.currentTarget).val() == "Fine Jewelry Appointment" || $(e.currentTarget).val() == "Timepiece Appointment" || $(e.currentTarget).val() == "Engagement Ring Appointment") {
			$('.store-location').removeClass('hide');
		} else {
			$('.store-location').addClass('hide');
		}
	}

	let scrollAfterLoad = () => {
		$(window).scrollTop(0);
	}

	init();

	$(document).on('shopify:section:load', init);
	
	$(document).on('scroll', (e) => animateLogo(e));
	$(document).on('scroll', (e) => animateDualLogo(e));
	$(document).on('click', '.menu .nav__link', (e) => toggleMenuBar(e));
	$(document).on('click', '.menu .nav-bar__sub-link-section', (e) => toggleMenuSubBar(e));
	$(document).on('click', '.header .hamburger', (e) => toggleMenu(e));
	//$(document).on('click', '.footer__column--menu .footer__header', (e) => toggleFooterAccordeon(e));
  $(document).on('click', '.mobile-nav-wrapper--second .js-mobile-nav-second', (e) => toggleMobHeaderAccordeon(e));

	$(document).on('mousemove', '.featured-collection .card__link', (e) => mousemoveTextFeaturedCollection(e));
	$(document).on('mousemove', '.brands__item .card__link', (e) => mousemoveTextFeaturedCollection(e));
	$(document).on('click', '.accordeon .accordeon__header', (e) => toggleAccordeon(e));

	$(document).on('click', '.season-episodes__header', (e) => toggleSeason(e));

	$(document).on('click', '.accordeon .accordeon__close', (e) => toggleAccordeonClose(e));
	$(document).on('click', '.address-delete', (e) => deleteAccountAddress(e));

	$(document).on('click', '.boost-pfs-filter-button', () => loadFilter());
	$(document).on('click', '.boost-pfs-filter-show-result', () => loadFilter());
	$(window).on('resize', () => loadFilter());
	
	$(document).on('click', '.product .options__link', (e) => changeProductOptions(e));
	$(document).on('click', '.product .options--size-value', (e) => openSizePopup(e));
	$(document).on('click', '.product .options__popup-close, .product .options__link', (e) => closeSizePopup(e));

  $(document).on('click', '.product-info-bottom__popup-open', (e) => openProductPopup(e));
	$(document).on('click', '.product-info-bottom__popup-close', (e) => closeProductPopup(e));

	$(document).on('click', '.product-slider-full-width__close, .product-single__media', (e) => toggleProductSlider(e));
	$(document).on('click', '.product-tabs .tabs .tabs__headings-link', (e) => toggleProductTabs(e));
	$(document).on('click', '.product_notes-inner', (e) => toggleProductNotes(e));

	$(document).on('click', '.continue--screen', (e) => toggleScreen(e));
	$(document).on('click', '.continue--tab', (e) => toggleButtonTab(e));
	$(document).on('click', '.tabs__mob-back-button', (e) => toggleBackButtonTab(e)); 
	$(document).on('click', '.form-tab-bottom__back-button', (e) => toggleBackButtonTabForm(e));
	$(document).on('click', '.back--tab', (e) => toggleBackButtonTabEducationForm(e));
	$(document).on('click', '.multi__content', (e) => toggleScreenRevers(e));

	$(document).on('click', '.mob-sub-nav', (e) => toggleMobSubNav(e));
	$(document).on('click', '.close-mobile-nav', (e) => toggleMobileNav(e));

	$(document).on('click', '.mobile-nav', (e) => {
		const classes = e.target.className;
		if (classes === 'mobile-nav') {
			console.log('Clicked mobile nav', classes);
			toggleMobileNav(e);
		}
	});

	$(document).on('click', '.block-tabs .tabs__headings-link', (e) => toggleProductBlockTabs(e));

	$(document).on('click', '[data-modal-trigger]', (e) => togglePopupWindow(e, 'open'));
	$(document).on('click', '[data-modal-dismiss]', (e) => togglePopupWindow(e, 'mouseClose'));
	$(document).on('keydown', (e) => togglePopupWindow(e, 'keyClose'));
	
	$(document).on('keyup', 'input.clone', (e) =>  cloneInput(e));
  $(document).on('submit','#42f5543a-837b-4cd3-ab09-2d457a045f57', (e) => csCustomForm(e));
	$(document).on('change', '.product_type--contact-form', (e) => toggleContactFormDatepicker(e));

	$(document).on('click', '.boost-pfs-filter-option-title-heading', (e) => addCustomTitleToCollectionFilter(e));
	$(document).on('click', '.bar__applied-filters--mobile', (e) => toggleCollectionFirstItem(e));
	$(document).on('click', '.header, .header *, .results, .results *', (e) => closeCollectionFilter(e));

	$(document).on('click', '.link-search__link', (e) => toggleHeaderSearch(e));
	$(document).on('click', '.search__close-btn', (e) => closeSearchDiv(e));

	$(document).on('click', '.boost-pfs-filter-option', (e) => addFilterUnderlines(e));

	$(document).on('change', '#what_is_your_preferred_cut_other', (e) => toggleEngagementFormInput(e));

	$(document).on('click', '.s-s-landing-page__link--text', (e) => showLandingEmailForm(e));
	$(document).on('click', '.s-s-landing-page__link--close', () => hideLandingEmailForm());
	$(document).on('click', '.klaviyo-form button', () => removeBlurLandingEmailForm());

	setTimeout(function(){
	addCustomTitleToCollectionFilter();
	changeRoleSearchPopup();
	},4000)
});
